import { render, staticRenderFns } from "./View.vue?vue&type=template&id=5dafe3a0"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dafe3a0')) {
      api.createRecord('5dafe3a0', component.options)
    } else {
      api.reload('5dafe3a0', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=5dafe3a0", function () {
      api.rerender('5dafe3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/FiscalCalendar/View.vue"
export default component.exports